module.exports = __webpack_public_path__ + "img/party_3_animal.d1e041b8.jpg";